export const isCapacitorPluginUnimplementedException = (e: any) => e === 'cordova_not_available' || e.code === 'UNIMPLEMENTED';
